module.exports = __webpack_public_path__ + "team-efficiency.3Gw9hzAD.svg";